<div *ngIf="!loginDisplay">
    <div class="form-container">
        <h2>Iniciar Sesión</h2>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <!-- Campo Correo Electrónico -->
          <div class="form-group">
            <label for="Email">Correo Electrónico</label>
            <input
              id="Email"
              type="Email"
              formControlName="Email"
              placeholder="Ingrese su correo electrónico"
            />
            <small *ngIf="controls['Email'].invalid && controls['Email'].touched" class="error">
              Ingrese un correo válido.
            </small>
          </div>
      
          <!-- Campo Contraseña -->
          <div class="form-group">
            <label for="Clave">Contraseña</label>
            <div class="Clave-container" style="display: flex; align-items: center; width: 100%;">
              <input
                id="Clave"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="Clave"
                placeholder="Ingrese su contraseña"
                style="flex: 1;"
              />
              <button type="button" class="toggle-password" (click)="togglePassword()" style="margin-left: 10px;">
                <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
              </button>
            </div>
            <small *ngIf="controls['Clave'].invalid && controls['Clave'].touched" class="error">
              La contraseña es obligatoria y debe tener al menos 6 caracteres.
            </small>
          </div>
      
          <!-- Botón Iniciar Sesión -->
          <div class="form-group">
            <button type="submit" [disabled]="loginForm.invalid">Iniciar Sesión</button>
          </div>
        </form>
    </div>
</div>

<div *ngIf="loginDisplay">
    <p>Login successful!</p>
    <p>Call a B2C protected web API by selecting the Hello API link above.</p>
    <p>Claims in your ID token are shown below: </p>
</div>

<!-- <table mat-table id="idTokenClaims" [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="loginDisplay">

    
    <ng-container matColumnDef="claim">
        <th mat-header-cell *matHeaderCellDef> Claim </th>
        <td mat-cell *matCellDef="let element"> {{element.claim}} </td>
    </ng-container>

    
    <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> Value </th>
        <td mat-cell *matCellDef="let element"> {{element.value}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table> -->